import { LanguageCode } from "./language";
import { UserDefaultType, UserKeysTypes } from "./user";

export enum EnvironmentName {
  local = "local",
  dev = "dev",
  uat = "uat",
  prod = "prod",
}
export interface EnvironmentAuth {
  local_storage_var_name: string;
  access_token_path: string;
  company_id_path: string;
  email_id_path: string;
  first_name_path: string;
  last_name_path: string;
  phone_number_path: string;
  user_role_path: string;
  user_type_path: string;
  user_id_path: string;
  user_location_path?: string;
  user_locale_path?: string;
};

export interface Queue {
    accepted_values?: Array<string>,
    default_agent_language?: LanguageCode,
    exclude_values?: Array<string>,

}
export interface DynamicQueue {
  preprocessing: (value:string) => Array<string>,
  user_value: UserKeysTypes
  rules: {
    [queue_name:string] : Queue
  }
}

export interface Environment {
  env: EnvironmentName;
  bot: EnvironmentBot;
  protocol: string;
  visible: boolean;
  url: EnvironmentUrls;
  default_queue:string,
  dynamic_queue?: DynamicQueue,
  mandatory_properties:{
    [key:string]: Array<string>
  };
  auth: EnvironmentAuth;
  allowed_paths: Array<string>;
  envEndpoint: {
    api: {
      backend: string;
      firestore: string;
      saveTranscript: string;
      engagementLanguage: string;
    };
    static: {
      media: string;
    };
  };

}

export interface EnvironmentBot {
  name: string;
}

export interface EnvironmentUrls {
  axp: EnvironmentUrl;
  api: EnvironmentUrl;
  static: EnvironmentUrl;
  [key: string]: EnvironmentUrl;
}

export interface EnvironmentUrl {
  host: string;
  entrypoint?: string;
  protocol?: string;
}

export interface EnvironmentConfig {
  env: EnvironmentName;
  bot: {
    name: string;
  };
  visible: boolean;
  url: {
    axp: {
      base: string;
    };
    api: {
      base: string;
      auth: string;
      firestore: string;
      saveTranscript: string;
      engagementLanguage:string
    };
    static: {
      base: string;
      assets: string;
    };
    gTranslate: {
      base: string;
    }, 
    cloudFunction: {
      base: string;
    }
  };
  allowed_paths: Array<string>;
  mandatory_properties:{
    [key:string]: Array<string>
  };
  default_queue:string;
  auth:EnvironmentAuth;
  getMediaUrl: (name: string) => string;
  getQueue(user: UserDefaultType): string;
  getDefaultAgentLanguage(queue:string): LanguageCode;
  
}

